import { useState, useEffect, useRef } from "react";
import { supabase } from "./supabaseClient";

const T = {
  cream: "#FAF9F6", creamDeep: "#F5F3EE", charcoal: "#2C2C2C", charcoalLight: "#4A4A4A",
  gold: "#C5A572", goldLight: "#D4BC92", goldDark: "#A88B5A", white: "#FFFFFF",
  border: "#E8E4DD", borderLight: "#F0ECE6", muted: "#8A8580", faint: "#B5B0AA",
  success: "#5A8A4A", successBg: "rgba(90,138,74,0.08)", danger: "#C0392B",
};

const MATERIALES_DATA = {
  gavetasBody: [
    { id: "gb1", nombre: "Blanco Nieve", hex: "#F5F5F0" },
    { id: "gb2", nombre: "Gris Cemento", hex: "#9A9A92" },
    { id: "gb3", nombre: "Grafito", hex: "#4A4A48" },
    { id: "gb4", nombre: "Arena Natural", hex: "#C8B89A" },
    { id: "gb5", nombre: "Nuez Oscuro", hex: "#6B4C3B" },
    { id: "gb6", nombre: "Negro Mate", hex: "#2A2A2A" },
  ],
  tapas: [
    { id: "t1", nombre: "Blanco Polar", hex: "#F0EDE8", ref: "Color A" },
    { id: "t2", nombre: "Gris Perla", hex: "#C8C4BC", ref: "Color B" },
    { id: "t3", nombre: "Gris Pizarra", hex: "#7A7870", ref: "Color C" },
    { id: "t4", nombre: "Verde Salvia", hex: "#8A9E88", ref: "Color D" },
    { id: "t5", nombre: "Azul Ceniza", hex: "#7A8A96", ref: "Color E" },
    { id: "t6", nombre: "Terracota Suave", hex: "#B8896A", ref: "Color F" },
    { id: "t7", nombre: "Beige Lino", hex: "#D4C4A8", ref: "Color G" },
    { id: "t8", nombre: "Negro Profundo", hex: "#252422", ref: "Color H" },
  ],
  piedras: [
    { id: "p1", nombre: "Calacatta Gold", descripcion: "Blanco con venas doradas suaves", hex: "#F0EAD8", vena: "#C8A87A" },
    { id: "p2", nombre: "Gris Tormenta", descripcion: "Gris medio con movimiento dramatico", hex: "#9A9898", vena: "#6A6864" },
    { id: "p3", nombre: "Negro Marquina", descripcion: "Negro intenso con venas blancas", hex: "#2A2A2C", vena: "#E8E4DC" },
  ],
};

const fmt = n => "$" + Number(n).toLocaleString("en-US");
const fmtD = d => d ? new Date(d).toLocaleDateString("es-ES", { day: "numeric", month: "short", year: "numeric" }) : "-";
const fmtT = d => d ? new Date(d).toLocaleString("es-ES", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "";

const Ic = ({ d, s = 18, c = "currentColor" }) => (
  <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);

const I = {
  user: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z",
  lock: "M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2zM7 11V7a5 5 0 0 1 10 0v4",
  file: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6",
  dollar: "M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6",
  clock: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zM12 6v6l4 2",
  camera: "M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2zM12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
  msg: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
  palette: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10a2 2 0 0 0 2-2v-1a2 2 0 0 1 2-2h1a2 2 0 0 0 2-2V12a10 10 0 0 0-10-10z",
  check: "M20 6L9 17l-5-5",
  x: "M18 6L6 18M6 6l12 12",
  out: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9",
  up: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12",
  eye: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
  shield: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
  send: "M22 2L11 13M22 2l-7 20-4-9-9-4z",
  info: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zM12 16v-4M12 8h.01",
  pen: "M17 3a2.83 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z",
  plus: "M12 5v14M5 12h14",
  arrow: "M5 12h14M12 5l7 7-7 7",
};

const TABS = [
  { ic: I.user, l: "Datos" },
  { ic: I.file, l: "Scope" },
  { ic: I.dollar, l: "Pagos" },
  { ic: I.clock, l: "Timeline" },
  { ic: I.camera, l: "Fotos" },
  { ic: I.msg, l: "Mensajes" },
  { ic: I.palette, l: "Materiales" },
];

const C = { background: T.white, border: `1px solid ${T.border}`, borderRadius: 12, padding: 24, marginBottom: 14 };
const H = { fontFamily: "'Cormorant Garamond',serif", fontSize: 21, fontWeight: 400, color: T.charcoal, marginBottom: 3 };
const Sub = { fontSize: 13, color: T.muted, fontStyle: "italic", fontFamily: "'Cormorant Garamond',serif", marginBottom: 22 };
const Lbl = { fontSize: 10, fontWeight: 600, letterSpacing: ".1em", textTransform: "uppercase", color: T.muted, marginBottom: 5, display: "block" };
const Val = { fontSize: 14, color: T.charcoal, padding: "11px 14px", background: T.creamDeep, borderRadius: 8, border: `1px solid ${T.borderLight}` };
const Btn = { display: "inline-flex", alignItems: "center", gap: 7, padding: "11px 22px", background: `linear-gradient(135deg,${T.goldDark},${T.gold})`, color: T.white, border: "none", borderRadius: 8, fontSize: 12, fontWeight: 600, letterSpacing: ".05em", cursor: "pointer", boxShadow: "0 4px 14px rgba(197,165,114,.2)" };
const BtnO = { ...Btn, background: "transparent", color: T.gold, border: `1.5px solid ${T.gold}`, boxShadow: "none" };

function Spinner() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: T.cream }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ width: 40, height: 40, border: `3px solid ${T.borderLight}`, borderTop: `3px solid ${T.gold}`, borderRadius: "50%", animation: "spin 800ms linear infinite", margin: "0 auto 16px" }} />
        <p style={{ fontSize: 13, color: T.muted, fontFamily: "'Cormorant Garamond',serif", fontStyle: "italic" }}>Cargando...</p>
      </div>
    </div>
  );
}

export default function App() {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState(0);
  const [toast, setToast] = useState(null);
  const [projects, setProjects] = useState([]);
  const [pid, setPid] = useState(null);
  const [project, setProject] = useState(null);

  const show = (m) => { setToast({ m }); setTimeout(() => setToast(null), 3500); };

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      if (session?.user) loadProfile(session.user.id);
      else setLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
      if (session?.user) loadProfile(session.user.id);
      else { setProfile(null); setLoading(false); }
    });
    return () => subscription.unsubscribe();
  }, []);

  const loadProfile = async (uid) => {
    const { data } = await supabase.from("profiles").select("*").eq("id", uid).single();
    setProfile(data);
    setLoading(false);
  };

  useEffect(() => {
    if (!profile) return;
    if (profile.role === "admin") loadAllProjects();
    else if (profile.project_id) { setPid(profile.project_id); loadProject(profile.project_id); }
  }, [profile]);

  const loadAllProjects = async () => {
    const { data } = await supabase.from("projects").select("*").order("created_at", { ascending: false });
    setProjects(data || []);
  };

  const loadProject = async (id) => {
    const [
      { data: proj },
      { data: payments },
      { data: steps },
      { data: msgs },
      { data: photos },
      { data: scope },
      { data: mats },
    ] = await Promise.all([
      supabase.from("projects").select("*").eq("id", id).single(),
      supabase.from("payments").select("*").eq("project_id", id).order("id"),
      supabase.from("timeline_steps").select("*").eq("project_id", id).order("order_index"),
      supabase.from("messages").select("*").eq("project_id", id).order("created_at"),
      supabase.from("photos").select("*").eq("project_id", id).order("created_at"),
      supabase.from("scopes").select("*").eq("project_id", id).single(),
      supabase.from("materials").select("*").eq("project_id", id).single(),
    ]);
    setProject({
      ...proj,
      payments: payments || [],
      timeline: { steps: steps || [], fabricationWeeks: proj?.fabrication_weeks || 4, installDays: proj?.install_days || 2 },
      messages: msgs || [],
      photos: photos || [],
      scope: scope || {},
      materials: mats || {},
    });
  };

  const refreshProject = () => pid && loadProject(pid);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null); setProfile(null); setProject(null); setPid(null); setTab(0); setProjects([]);
  };

  if (loading) return <Spinner />;
  if (!user || !profile) return <Login />;

  const adm = profile.role === "admin";

  return (
    <div style={{ minHeight: "100vh", background: T.cream, fontFamily: "'DM Sans',sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,400&family=DM+Sans:wght@300;400;500;600;700&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::selection { background: rgba(197,165,114,.25); }
        input:focus, textarea:focus { outline: none; border-color: ${T.gold} !important; box-shadow: 0 0 0 3px rgba(197,165,114,.12); }
        @keyframes fi { from { opacity: 0; transform: translateX(-50%) translateY(10px); } to { opacity: 1; transform: translateX(-50%) translateY(0); } }
        @keyframes si { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes pulse { 0%,100% { box-shadow: 0 0 0 0 rgba(197,165,114,.3); } 50% { box-shadow: 0 0 0 8px rgba(197,165,114,0); } }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>

      <header style={{ background: T.white, borderBottom: `1px solid ${T.borderLight}`, padding: "0 24px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 56, position: "sticky", top: 0, zIndex: 100, boxShadow: "0 1px 6px rgba(44,44,44,.04)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 32, height: 32, borderRadius: "50%", background: `linear-gradient(135deg,${T.goldDark},${T.gold})`, display: "flex", alignItems: "center", justifyContent: "center", color: T.white, fontSize: 13, fontWeight: 700, fontFamily: "'Cormorant Garamond',serif" }}>M</div>
          <span style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 16, fontWeight: 500, color: T.charcoal }}>Maja Millwork Design</span>
          {adm && <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: ".12em", textTransform: "uppercase", color: T.gold, background: "rgba(197,165,114,.12)", padding: "2px 8px", borderRadius: 10 }}>Admin</span>}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ fontSize: 12, color: T.muted }}>{profile.name}</span>
          <button onClick={handleLogout} style={{ background: "none", border: "none", cursor: "pointer", color: T.muted, fontSize: 11, display: "flex", alignItems: "center", gap: 4 }}>
            <Ic d={I.out} s={13} /> Salir
          </button>
        </div>
      </header>

      {toast && (
        <div style={{ position: "fixed", bottom: 28, left: "50%", transform: "translateX(-50%)", background: T.charcoal, color: T.white, padding: "10px 22px", borderRadius: 8, fontSize: 13, fontWeight: 500, zIndex: 9999, boxShadow: "0 8px 28px rgba(0,0,0,.15)", display: "flex", alignItems: "center", gap: 8, animation: "fi 200ms ease-out" }}>
          <Ic d={I.check} s={14} c={T.goldLight} />{toast.m}
        </div>
      )}

      {adm
        ? <Admin projects={projects} pid={pid} setPid={id => { setPid(id); if (id) loadProject(id); }} tab={tab} setTab={setTab} show={show} project={project} refresh={refreshProject} loadAll={loadAllProjects} />
        : project
          ? <Client p={project} tab={tab} setTab={setTab} show={show} refresh={refreshProject} />
          : <Spinner />
      }
    </div>
  );
}

function Login() {
  const [e, setE] = useState("");
  const [p, setP] = useState("");
  const [err, setErr] = useState("");
  const [sp, setSp] = useState(false);
  const [loading, setLoading] = useState(false);

  const go = async () => {
    setLoading(true); setErr("");
    const { error } = await supabase.auth.signInWithPassword({ email: e.trim(), password: p });
    if (error) { setErr("Email o contrasena incorrectos"); setLoading(false); }
  };

  const inp = { width: "100%", padding: "13px 16px", border: `1px solid ${T.border}`, borderRadius: 8, fontSize: 14, fontFamily: "inherit", color: T.charcoal, background: T.white };
  const lbl = { fontSize: 10, fontWeight: 600, letterSpacing: ".1em", textTransform: "uppercase", color: T.muted, marginBottom: 6, display: "block" };

  return (
    <div style={{ minHeight: "100vh", background: T.cream, display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div style={{ width: "100%", maxWidth: 380, animation: "si 400ms ease-out" }}>
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <div style={{ width: 64, height: 64, borderRadius: "50%", background: `linear-gradient(135deg,${T.goldDark},${T.gold})`, display: "inline-flex", alignItems: "center", justifyContent: "center", color: T.white, fontSize: 24, fontWeight: 300, fontFamily: "'Cormorant Garamond',serif", boxShadow: "0 4px 20px rgba(197,165,114,.3)", marginBottom: 16 }}>M</div>
          <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 26, fontWeight: 400, color: T.charcoal, marginBottom: 4 }}>Maja Millwork Design</h1>
          <p style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 15, color: T.muted, fontStyle: "italic" }}>Portal de Clientes</p>
        </div>
        <div style={{ background: T.white, border: `1px solid ${T.border}`, borderRadius: 12, padding: 28, boxShadow: "0 4px 20px rgba(44,44,44,.05)" }}>
          <div style={{ marginBottom: 18 }}>
            <label style={lbl}>Email</label>
            <input type="email" value={e} onChange={x => { setE(x.target.value); setErr(""); }} placeholder="su@email.com" style={inp} onKeyDown={x => x.key === "Enter" && go()} />
          </div>
          <div style={{ marginBottom: 22 }}>
            <label style={lbl}>Contrasena</label>
            <div style={{ position: "relative" }}>
              <input type={sp ? "text" : "password"} value={p} onChange={x => { setP(x.target.value); setErr(""); }} placeholder="password" style={{ ...inp, paddingRight: 40 }} onKeyDown={x => x.key === "Enter" && go()} />
              <button onClick={() => setSp(!sp)} style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: T.muted }}>
                <Ic d={I.eye} s={15} />
              </button>
            </div>
          </div>
          {err && <p style={{ color: T.danger, fontSize: 12, marginBottom: 14, display: "flex", alignItems: "center", gap: 5 }}><Ic d={I.info} s={13} c={T.danger} />{err}</p>}
          <button onClick={go} disabled={loading || !e || !p} style={{ width: "100%", padding: "13px", background: `linear-gradient(135deg,${T.goldDark},${T.gold})`, color: T.white, border: "none", borderRadius: 8, fontSize: 13, fontWeight: 600, letterSpacing: ".08em", cursor: "pointer", opacity: loading ? .7 : 1 }}>
            {loading ? "Ingresando..." : "INGRESAR"}
          </button>
        </div>
      </div>
    </div>
  );
}

function Nav({ tabs, tab, setTab, can, badge = -1 }) {
  return (
    <nav style={{ display: "flex", gap: 3, marginBottom: 28, overflowX: "auto", paddingBottom: 4 }}>
      {tabs.map((t, i) => {
        const ok = can(i); const on = tab === i;
        return (
          <button key={i} onClick={() => ok && setTab(i)} style={{ display: "flex", alignItems: "center", gap: 5, padding: "9px 14px", borderRadius: 8, border: "none", fontSize: 12, fontWeight: on ? 600 : 400, background: on ? T.white : "transparent", color: !ok ? T.faint : on ? T.charcoal : T.muted, cursor: ok ? "pointer" : "not-allowed", transition: "all 180ms", boxShadow: on ? "0 2px 6px rgba(44,44,44,.05)" : "none", opacity: ok ? 1 : .5, whiteSpace: "nowrap", flexShrink: 0 }}>
            <Ic d={t.ic} s={14} c={on ? T.gold : ok ? T.muted : T.faint} />{t.l}
            {!ok && <Ic d={I.lock} s={10} c={T.faint} />}
            {badge === i && <span style={{ width: 6, height: 6, borderRadius: "50%", background: T.gold }} />}
          </button>
        );
      })}
    </nav>
  );
}

function Client({ p, tab, setTab, show, refresh }) {
  const can = i => {
    if (i <= 1) return true;
    if (i === 2) return p.scope?.signed;
    if (i >= 3) return p.payments?.some(x => x.status === "confirmed");
    return true;
  };
  return (
    <div style={{ maxWidth: 860, margin: "0 auto", padding: "20px 16px 60px" }}>
      <Nav tabs={TABS} tab={tab} setTab={setTab} can={can} />
      <div style={{ animation: "si 250ms ease-out" }} key={tab}>
        {tab === 0 && <TDatos p={p} />}
        {tab === 1 && <TScope p={p} show={show} refresh={refresh} />}
        {tab === 2 && <TPagos p={p} show={show} refresh={refresh} />}
        {tab === 3 && <TTl p={p} />}
        {tab === 4 && <TFotos p={p} show={show} refresh={refresh} />}
        {tab === 5 && <TMsgs p={p} show={show} refresh={refresh} role="client" />}
        {tab === 6 && <TMats p={p} show={show} refresh={refresh} />}
      </div>
    </div>
  );
}

function Admin({ projects, pid, setPid, tab, setTab, show, project, refresh, loadAll }) {
  if (!pid) return (
    <div style={{ maxWidth: 760, margin: "0 auto", padding: "36px 16px" }}>
      <div style={{ marginBottom: 28 }}>
        <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 26, fontWeight: 400 }}>Proyectos</h2>
        <p style={{ fontSize: 12, color: T.muted, marginTop: 3 }}>{projects.length} activo{projects.length !== 1 ? "s" : ""}</p>
      </div>
      {projects.length === 0 && <p style={{ fontSize: 13, color: T.muted, textAlign: "center", padding: 40 }}>No hay proyectos aun.</p>}
      {projects.map(proj => (
        <div key={proj.id} onClick={() => { setPid(proj.id); setTab(0); }} style={{ background: T.white, border: `1px solid ${T.border}`, borderRadius: 12, padding: 22, marginBottom: 10, cursor: "pointer", boxShadow: "0 1px 3px rgba(44,44,44,.03)", transition: "box-shadow 200ms" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 19, fontWeight: 500 }}>{proj.client_name}</h3>
              <p style={{ fontSize: 11, color: T.muted, marginTop: 3 }}>{proj.client_address}</p>
            </div>
            <div style={{ fontSize: 17, fontWeight: 600, fontFamily: "'Cormorant Garamond',serif" }}>{fmt(proj.total)}</div>
          </div>
        </div>
      ))}
    </div>
  );

  if (!project) return <Spinner />;

  return (
    <div style={{ maxWidth: 860, margin: "0 auto", padding: "20px 16px 60px" }}>
      <button onClick={() => { setPid(null); setTab(0); loadAll(); }} style={{ background: "none", border: "none", color: T.muted, fontSize: 12, cursor: "pointer", marginBottom: 16 }}>
        Todos los proyectos
      </button>
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 24, fontWeight: 400 }}>{project.client_name}</h2>
        <p style={{ fontSize: 12, color: T.muted }}>{project.client_address} - {fmt(project.total)}</p>
      </div>
      <Nav tabs={TABS} tab={tab} setTab={setTab} can={() => true} badge={project.payments?.some(x => x.status === "pending_review") ? 2 : -1} />
      <div style={{ animation: "si 250ms ease-out" }} key={tab}>
        {tab === 0 && <TDatos p={project} adm />}
        {tab === 1 && <TScope p={project} show={show} refresh={refresh} adm />}
        {tab === 2 && <TPagos p={project} show={show} refresh={refresh} adm />}
        {tab === 3 && <TTl p={project} show={show} refresh={refresh} adm />}
        {tab === 4 && <TFotos p={project} show={show} refresh={refresh} adm />}
        {tab === 5 && <TMsgs p={project} show={show} refresh={refresh} role="admin" />}
        {tab === 6 && <TMats p={project} show={show} refresh={refresh} adm />}
      </div>
    </div>
  );
}

function TDatos({ p }) {
  return (
    <div>
      <h2 style={H}>Informacion del Proyecto</h2>
      <p style={Sub}>Datos personales y direccion</p>
      <div style={C}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
          {[["Nombre completo", p.client_name], ["Telefono", p.client_phone], ["Email", p.client_email]].map(([l, v], i) => (
            <div key={i}><label style={Lbl}>{l}</label><div style={Val}>{v}</div></div>
          ))}
          <div style={{ gridColumn: "1/-1" }}><label style={Lbl}>Direccion del proyecto</label><div style={Val}>{p.client_address}</div></div>
        </div>
        <div style={{ marginTop: 20, padding: "14px 18px", background: "linear-gradient(135deg,rgba(197,165,114,.07),rgba(197,165,114,.02))", borderRadius: 8, borderLeft: `3px solid ${T.gold}`, display: "flex", gap: 10 }}>
          <Ic d={I.shield} s={16} c={T.gold} />
          <p style={{ fontSize: 12, color: T.charcoalLight, lineHeight: 1.6 }}>Su informacion esta protegida y es de uso exclusivo para su proyecto.</p>
        </div>
      </div>
    </div>
  );
}

function TScope({ p, show, refresh, adm }) {
  const [nm, setNm] = useState("");
  const [ok, setOk] = useState(false);
  const [uploading, setUploading] = useState(false);
  const sc = p.scope || {};

  const uploadScope = async (e) => {
    const file = e.target.files[0];
    if (!file || file.type !== "application/pdf") { show("Solo se permiten archivos PDF"); return; }
    setUploading(true);
    const path = `scopes/${p.id}/${file.name}`;
    const { error } = await supabase.storage.from("project-files").upload(path, file, { upsert: true });
    if (error) { show("Error al subir el archivo"); setUploading(false); return; }
    await supabase.from("scopes").update({ file_name: file.name, file_path: path }).eq("project_id", p.id);
    show("Scope subido correctamente");
    setUploading(false);
    refresh();
  };

  const sign = async () => {
    if (!nm.trim() || !ok) return;
    await supabase.from("scopes").update({ signed: true, signature: nm.trim(), signed_at: new Date().toISOString(), signed_ip: "client" }).eq("project_id", p.id);
    show("Scope firmado exitosamente");
    refresh();
  };

  const viewScope = async () => {
    const { data } = await supabase.storage.from("project-files").createSignedUrl(sc.file_path, 60);
    if (data?.signedUrl) window.open(data.signedUrl, "_blank");
  };

  return (
    <div>
      <h2 style={H}>Scope of Work</h2>
      <p style={Sub}>Alcance y contrato del proyecto</p>
      <div style={C}>
        <div style={{ background: T.creamDeep, border: `1px dashed ${T.border}`, borderRadius: 8, padding: "36px 20px", textAlign: "center", marginBottom: 20 }}>
          <Ic d={I.file} s={36} c={T.gold} />
          <p style={{ fontSize: 14, fontWeight: 500, marginTop: 10, color: T.charcoal }}>{sc.file_name || "Sin archivo aun"}</p>
          <p style={{ fontSize: 11, color: T.muted, marginTop: 3 }}>PDF del alcance y estimado</p>
          <div style={{ display: "flex", gap: 8, justifyContent: "center", marginTop: 14, flexWrap: "wrap" }}>
            {sc.file_path && <button onClick={viewScope} style={{ ...BtnO, padding: "7px 18px", fontSize: 11 }}><Ic d={I.eye} s={13} /> Ver</button>}
            {adm && (
              <label style={{ ...BtnO, padding: "7px 18px", fontSize: 11, cursor: "pointer" }}>
                <input type="file" accept=".pdf" onChange={uploadScope} style={{ display: "none" }} />
                {uploading ? "Subiendo..." : <><Ic d={I.up} s={13} /> {sc.file_name ? "Reemplazar" : "Subir PDF"}</>}
              </label>
            )}
          </div>
        </div>
        {sc.signed ? (
          <div style={{ background: T.successBg, border: "1px solid rgba(90,138,74,.2)", borderRadius: 8, padding: 20 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 10 }}>
              <div style={{ width: 28, height: 28, borderRadius: "50%", background: T.success, display: "flex", alignItems: "center", justifyContent: "center" }}><Ic d={I.check} s={14} c={T.white} /></div>
              <div><strong style={{ fontSize: 13, color: T.success }}>Firmado</strong><p style={{ fontSize: 10, color: T.muted }}>No modificable</p></div>
            </div>
            <div style={{ fontSize: 11, color: T.charcoalLight, lineHeight: 2 }}>
              <div><b>Firmado por:</b> {sc.signature}</div>
              <div><b>Fecha:</b> {fmtT(sc.signed_at)}</div>
              <div><b>Hash:</b> {sc.doc_hash}</div>
            </div>
          </div>
        ) : !adm && sc.file_name && (
          <div style={{ borderTop: `1px solid ${T.borderLight}`, paddingTop: 20 }}>
            <h4 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 17, marginBottom: 14 }}>Firma Digital</h4>
            <p style={{ fontSize: 12, color: T.charcoalLight, marginBottom: 18, lineHeight: 1.6 }}>Al firmar, acepta el alcance, terminos y estimado.</p>
            <div style={{ marginBottom: 14 }}>
              <label style={Lbl}>Escriba su nombre completo</label>
              <input type="text" value={nm} onChange={e => setNm(e.target.value)} placeholder="Nombre y Apellido" style={{ width: "100%", padding: "13px 14px", border: `1px solid ${T.border}`, borderRadius: 8, fontSize: 17, fontFamily: "'Cormorant Garamond',serif", fontStyle: "italic", color: T.charcoal }} />
            </div>
            <label style={{ display: "flex", alignItems: "flex-start", gap: 9, cursor: "pointer", marginBottom: 18 }}>
              <input type="checkbox" checked={ok} onChange={e => setOk(e.target.checked)} style={{ marginTop: 2, accentColor: T.gold }} />
              <span style={{ fontSize: 12, color: T.charcoalLight, lineHeight: 1.6 }}>He leido y acepto el Scope of Work. Entiendo que una vez firmado no podra modificarse.</span>
            </label>
            <button onClick={sign} disabled={!nm.trim() || !ok} style={{ ...Btn, opacity: (!nm.trim() || !ok) ? .5 : 1, cursor: (!nm.trim() || !ok) ? "not-allowed" : "pointer" }}>
              <Ic d={I.pen} s={13} c={T.white} /> Firmar Documento
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

function TPagos({ p, show, refresh, adm }) {
  const [upl, setUpl] = useState(null);
  const [uploading, setUploading] = useState(false);

  const uploadProof = async (id, file) => {
    if (!file) return;
    setUploading(true);
    const path = `proofs/${p.id}/${id}_${file.name}`;
    const { error } = await supabase.storage.from("project-files").upload(path, file, { upsert: true });
    if (error) { show("Error al subir comprobante"); setUploading(false); return; }
    await supabase.from("payments").update({ status: "pending_review", proof: path }).eq("id", id);
    show("Comprobante enviado correctamente");
    setUploading(false); setUpl(null);
    refresh();
  };

  const conf = async (payId) => {
    await supabase.from("payments").update({ status: "confirmed", confirmed_at: new Date().toISOString() }).eq("id", payId);
    const idx = p.payments.findIndex(x => x.id === payId);
    if (idx >= 0 && idx < p.payments.length - 1) {
      await supabase.from("payments").update({ status: "pending" }).eq("id", p.payments[idx + 1].id);
    }
    if (idx === 0) {
      await supabase.from("timeline_steps").update({ status: "completed", step_date: new Date().toISOString() }).eq("id", "t1").eq("project_id", p.id);
    }
    show("Pago confirmado");
    refresh();
  };

  const sc = {
    locked: { bg: T.creamDeep, c: T.faint, l: "Bloqueado" },
    pending: { bg: "rgba(197,165,114,.08)", c: T.gold, l: "Pendiente" },
    pending_review: { bg: "rgba(197,165,114,.15)", c: T.goldDark, l: "En Revision" },
    confirmed: { bg: T.successBg, c: T.success, l: "Confirmado" },
  };

  return (
    <div>
      <h2 style={H}>Pagos</h2>
      <p style={Sub}>Estructura de pagos - {fmt(p.total)} total</p>
      <div style={{ ...C, background: "linear-gradient(135deg,rgba(197,165,114,.05),rgba(197,165,114,.01))", borderColor: T.gold, marginBottom: 20 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 6 }}><Ic d={I.info} s={16} c={T.gold} /><strong style={{ fontSize: 13, color: T.charcoal }}>Pago via Zelle</strong></div>
        <p style={{ fontSize: 12, color: T.charcoalLight, lineHeight: 1.6 }}>Envie su pago por Zelle y suba captura del comprobante. Confirmaremos en 24h habiles.</p>
      </div>
      {(p.payments || []).map(pay => {
        const s = sc[pay.status] || sc.locked;
        return (
          <div key={pay.id} style={{ ...C, opacity: pay.status === "locked" ? .55 : 1 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
              <div>
                <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: ".1em", textTransform: "uppercase", color: s.c, background: s.bg, padding: "3px 9px", borderRadius: 10, display: "inline-block", marginBottom: 6 }}>{s.l}</span>
                <h4 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 16, fontWeight: 500 }}>{pay.label}</h4>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: 22, fontWeight: 300, fontFamily: "'Cormorant Garamond',serif" }}>{fmt(pay.amount)}</div>
                <div style={{ fontSize: 10, color: T.muted }}>{pay.pct}%</div>
              </div>
            </div>
            {pay.status === "confirmed" && <div style={{ display: "flex", alignItems: "center", gap: 7, padding: "9px 12px", background: T.successBg, borderRadius: 6, fontSize: 11, color: T.success }}><Ic d={I.check} s={13} c={T.success} />Confirmado {fmtD(pay.confirmed_at)}</div>}
            {pay.status === "pending" && !adm && (
              upl === pay.id
                ? <div style={{ display: "flex", gap: 7, alignItems: "center" }}>
                  <label style={{ ...Btn, cursor: "pointer" }}>
                    <input type="file" accept="image/*,.pdf" onChange={e => uploadProof(pay.id, e.target.files[0])} style={{ display: "none" }} />
                    {uploading ? "Subiendo..." : <><Ic d={I.up} s={13} c={T.white} /> Seleccionar archivo</>}
                  </label>
                  <button onClick={() => setUpl(null)} style={BtnO}>Cancelar</button>
                </div>
                : <button onClick={() => setUpl(pay.id)} style={Btn}><Ic d={I.up} s={13} c={T.white} /> Subir Comprobante Zelle</button>
            )}
            {pay.status === "pending_review" && (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 14px", background: "rgba(197,165,114,.07)", borderRadius: 8, border: "1px solid rgba(197,165,114,.18)" }}>
                <span style={{ fontSize: 12, color: T.goldDark, display: "flex", alignItems: "center", gap: 6 }}><Ic d={I.clock} s={13} c={T.gold} />Esperando confirmacion</span>
                {adm && <button onClick={() => conf(pay.id)} style={{ ...Btn, padding: "7px 14px", fontSize: 11 }}><Ic d={I.check} s={11} c={T.white} /> Confirmar</button>}
              </div>
            )}
            {pay.status === "locked" && <div style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 11, color: T.faint }}><Ic d={I.lock} s={13} c={T.faint} />Se habilita al completar el paso anterior</div>}
          </div>
        );
      })}
    </div>
  );
}

function TTl({ p, show, refresh, adm }) {
  const steps = p.timeline?.steps || [];

  const upd = async (sid, st) => {
    await supabase.from("timeline_steps").update({ status: st, step_date: st === "completed" ? new Date().toISOString() : null }).eq("id", sid).eq("project_id", p.id);
    show("Timeline actualizado");
    refresh();
  };

  const si = st => st === "completed"
    ? <div style={{ width: 26, height: 26, borderRadius: "50%", background: T.success, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}><Ic d={I.check} s={13} c={T.white} /></div>
    : st === "in_progress"
      ? <div style={{ width: 26, height: 26, borderRadius: "50%", background: T.gold, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, animation: "pulse 2s infinite" }}><div style={{ width: 7, height: 7, borderRadius: "50%", background: T.white }} /></div>
      : <div style={{ width: 26, height: 26, borderRadius: "50%", border: `2px solid ${T.border}`, flexShrink: 0 }} />;

  return (
    <div>
      <h2 style={H}>Timeline</h2>
      <p style={Sub}>Progreso de su proyecto</p>
      <div style={C}>
        {steps.map((s, i) => (
          <div key={s.id} style={{ display: "flex", gap: 14, position: "relative", paddingBottom: i < steps.length - 1 ? 28 : 0 }}>
            {i < steps.length - 1 && <div style={{ position: "absolute", left: 12, top: 28, bottom: 0, width: 2, background: s.status === "completed" ? T.success : T.borderLight }} />}
            {si(s.status)}
            <div style={{ flex: 1 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h4 style={{ fontSize: 14, fontWeight: s.status === "in_progress" ? 600 : 400, color: s.status === "pending" ? T.muted : T.charcoal }}>{s.label}</h4>
                {s.step_date && <span style={{ fontSize: 11, color: T.muted }}>{fmtD(s.step_date)}</span>}
              </div>
              {adm && s.status !== "completed" && (
                <div style={{ display: "flex", gap: 5, marginTop: 6 }}>
                  {s.status === "pending" && <button onClick={() => upd(s.id, "in_progress")} style={{ fontSize: 10, padding: "3px 10px", borderRadius: 4, border: `1px solid ${T.gold}`, background: "transparent", color: T.gold, cursor: "pointer" }}>Iniciar</button>}
                  <button onClick={() => upd(s.id, "completed")} style={{ fontSize: 10, padding: "3px 10px", borderRadius: 4, border: `1px solid ${T.success}`, background: "transparent", color: T.success, cursor: "pointer" }}>Completar</button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <div style={{ ...C, background: T.creamDeep }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 14, textAlign: "center" }}>
          {[["Fabricacion", (p.timeline?.fabricationWeeks || 4) + " sem"], ["Instalacion", (p.timeline?.installDays || 2) + " dias"], ["Progreso", Math.round((steps.filter(s => s.status === "completed").length / (steps.length || 1)) * 100) + "%"]].map(([l, v], i) => (
            <div key={i}>
              <div style={{ fontSize: 10, fontWeight: 600, letterSpacing: ".1em", textTransform: "uppercase", color: T.muted, marginBottom: 3 }}>{l}</div>
              <div style={{ fontSize: 19, fontFamily: "'Cormorant Garamond',serif", color: i === 2 ? T.gold : T.charcoal }}>{v}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function TFotos({ p, show, refresh, adm }) {
  const cats = [["initial", "Fotos Iniciales", "Estado actual"], ["render", "Renders", "Visualizaciones 3D"], ["elevation", "Elevaciones", "Planos tecnicos"], ["progress", "Progreso", "Avance del proyecto"]];
  const [uploading, setUploading] = useState(false);
  const [signedUrls, setSignedUrls] = useState({});

  useEffect(() => {
    const fetchUrls = async () => {
      const urls = {};
      for (const photo of (p.photos || [])) {
        if (photo.storage_path) {
          const { data } = await supabase.storage.from("project-files").createSignedUrl(photo.storage_path, 3600);
          if (data?.signedUrl) urls[photo.id] = data.signedUrl;
        }
      }
      setSignedUrls(urls);
    };
    fetchUrls();
  }, [p.photos]);

  const upload = async (type, file) => {
    if (!file) return;
    setUploading(true);
    const path = `photos/${p.id}/${type}_${Date.now()}_${file.name}`;
    const { error } = await supabase.storage.from("project-files").upload(path, file);
    if (error) { show("Error al subir foto"); setUploading(false); return; }
    await supabase.from("photos").insert({ id: `ph${Date.now()}`, project_id: p.id, name: file.name, type, storage_path: path, uploaded_by: adm ? "admin" : "client" });
    show("Foto subida correctamente");
    setUploading(false);
    refresh();
  };

  return (
    <div>
      <h2 style={H}>Fotos y Renders</h2>
      <p style={Sub}>Imagenes de cada etapa</p>
      {cats.map(([k, l, d]) => {
        const ph = (p.photos || []).filter(x => x.type === k);
        return (
          <div key={k} style={C}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
              <div><h4 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 16, fontWeight: 500 }}>{l}</h4><p style={{ fontSize: 11, color: T.muted }}>{d}</p></div>
              <label style={{ ...BtnO, padding: "6px 14px", fontSize: 10, cursor: "pointer" }}>
                <input type="file" accept="image/*,.pdf" onChange={e => upload(k, e.target.files[0])} style={{ display: "none" }} />
                {uploading ? "Subiendo..." : <><Ic d={I.up} s={11} /> Subir</>}
              </label>
            </div>
            {ph.length > 0
              ? <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(130px,1fr))", gap: 10 }}>
                {ph.map(x => (
                  <div key={x.id} style={{ borderRadius: 8, overflow: "hidden", border: `1px solid ${T.borderLight}`, aspectRatio: "4/3", background: T.creamDeep }}>
                    {signedUrls[x.id]
                      ? <img src={signedUrls[x.id]} alt={x.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                      : <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}><Ic d={I.camera} s={22} c={T.border} /><p style={{ fontSize: 9, color: T.muted, marginTop: 4, textAlign: "center", padding: "0 6px" }}>{x.name?.substring(0, 18)}</p></div>
                    }
                  </div>
                ))}
              </div>
              : <div style={{ padding: 20, textAlign: "center", background: T.creamDeep, borderRadius: 8, border: `1px dashed ${T.border}` }}><p style={{ fontSize: 12, color: T.faint }}>Sin fotos aun</p></div>
            }
          </div>
        );
      })}
    </div>
  );
}

function TMsgs({ p, show, refresh, role }) {
  const [txt, setTxt] = useState("");
  const [sending, setSending] = useState(false);
  const ref = useRef(null);

  useEffect(() => { if (ref.current) ref.current.scrollTop = ref.current.scrollHeight; }, [p.messages]);

  const send = async () => {
    if (!txt.trim()) return;
    setSending(true);
    await supabase.from("messages").insert({ id: "m" + Date.now(), project_id: p.id, from_role: role, from_name: role === "admin" ? "Maja Millwork" : p.client_name, text: txt.trim() });
    setTxt("");
    setSending(false);
    refresh();
  };

  return (
    <div>
      <h2 style={H}>Mensajes</h2>
      <p style={Sub}>Comunicacion directa</p>
      <div style={{ ...C, padding: 0, overflow: "hidden", display: "flex", flexDirection: "column", height: 460 }}>
        <div ref={ref} style={{ flex: 1, overflowY: "auto", padding: 20, display: "flex", flexDirection: "column", gap: 14 }}>
          {(p.messages || []).map(m => {
            const mine = m.from_role === role;
            return (
              <div key={m.id} style={{ display: "flex", flexDirection: "column", alignItems: mine ? "flex-end" : "flex-start", maxWidth: "78%", alignSelf: mine ? "flex-end" : "flex-start" }}>
                <div style={{ padding: "10px 14px", borderRadius: 12, borderBottomRightRadius: mine ? 4 : 12, borderBottomLeftRadius: mine ? 12 : 4, background: mine ? `linear-gradient(135deg,${T.goldDark},${T.gold})` : T.creamDeep, color: mine ? T.white : T.charcoal, fontSize: 13, lineHeight: 1.6 }}>{m.text}</div>
                <span style={{ fontSize: 9, color: T.faint, marginTop: 3, padding: "0 3px" }}>{m.from_name} - {fmtT(m.created_at)}</span>
              </div>
            );
          })}
        </div>
        <div style={{ borderTop: `1px solid ${T.borderLight}`, padding: 14, display: "flex", gap: 8, background: T.white }}>
          <input type="text" value={txt} onChange={e => setTxt(e.target.value)} onKeyDown={e => e.key === "Enter" && !sending && send()} placeholder="Escriba su mensaje..." style={{ flex: 1, padding: "10px 14px", border: `1px solid ${T.border}`, borderRadius: 8, fontSize: 13, fontFamily: "inherit", color: T.charcoal, background: T.creamDeep }} />
          <button onClick={send} disabled={!txt.trim() || sending} style={{ ...Btn, padding: "10px 14px", opacity: txt.trim() ? 1 : .5 }}>
            <Ic d={I.send} s={14} c={T.white} />
          </button>
        </div>
      </div>
    </div>
  );
}

function TMats({ p, show, refresh, adm }) {
  const mats = p.materials || {};
  const sel = mats.selecciones || {};

  const setVal = async (key, value) => {
    const newSel = { ...sel, [key]: value };
    await supabase.from("materials").update({ selecciones: newSel }).eq("project_id", p.id);
    refresh();
  };

  const handleApplPDF = async (e) => {
    const file = e.target.files[0];
    if (!file || file.type !== "application/pdf") { show("Solo se permiten archivos PDF"); return; }
    const path = `appliances/${p.id}/${file.name}`;
    const { error } = await supabase.storage.from("project-files").upload(path, file, { upsert: true });
    if (error) { show("Error al subir el PDF"); return; }
    await supabase.from("materials").update({ appliance_pdf: { name: file.name, path, uploadedAt: new Date().toISOString() } }).eq("project_id", p.id);
    show("PDF adjuntado correctamente");
    refresh();
  };

  const confirmar = async () => {
    if (!sel.gavetaBody || !sel.tapa || !sel.piedra) { show("Complete gavetas, tapas y piedra antes de confirmar"); return; }
    await supabase.from("materials").update({ completed: true, completed_at: new Date().toISOString() }).eq("project_id", p.id);
    show("Selecciones confirmadas exitosamente");
    refresh();
  };

  if (mats.completed) {
    return (
      <div>
        <h2 style={H}>Seleccion de Materiales</h2>
        <p style={Sub}>Acabados confirmados</p>
        <div style={{ ...C, textAlign: "center", padding: "40px 24px" }}>
          <div style={{ width: 56, height: 56, borderRadius: "50%", background: T.successBg, display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}><Ic d={I.check} s={28} c={T.success} /></div>
          <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 20, marginBottom: 8 }}>Selecciones Confirmadas</h3>
          <p style={{ fontSize: 12, color: T.muted, marginBottom: 24 }}>Todos los materiales han sido elegidos y enviados al equipo.</p>
          {adm && <button onClick={async () => { await supabase.from("materials").update({ completed: false }).eq("project_id", p.id); refresh(); }} style={{ ...BtnO, padding: "8px 18px", fontSize: 11 }}>Reabrir seleccion</button>}
        </div>
      </div>
    );
  }

  return (
    <div>
      <h2 style={H}>Seleccion de Materiales</h2>
      <p style={Sub}>Elija los acabados de su cocina</p>

      <div style={C}>
        <div style={{ marginBottom: 16 }}>
          <h4 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 17, fontWeight: 500, marginBottom: 3 }}>Color de Gavetas</h4>
          <p style={{ fontSize: 12, color: T.muted }}>Cuerpo interior (excluye tapas)</p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))", gap: 10 }}>
          {MATERIALES_DATA.gavetasBody.map(color => {
            const selected = sel.gavetaBody === color.id;
            return (
              <button key={color.id} onClick={() => setVal("gavetaBody", color.id)} style={{ border: selected ? `2px solid ${T.gold}` : `1px solid ${T.border}`, borderRadius: 10, padding: "12px 10px", background: selected ? "rgba(197,165,114,.06)" : T.white, cursor: "pointer", transition: "all 180ms", textAlign: "center", position: "relative" }}>
                {selected && <div style={{ position: "absolute", top: 6, right: 6, width: 16, height: 16, borderRadius: "50%", background: T.gold, display: "flex", alignItems: "center", justifyContent: "center" }}><Ic d={I.check} s={9} c={T.white} /></div>}
                <div style={{ width: 44, height: 44, borderRadius: 8, background: color.hex, border: "1px solid rgba(0,0,0,.08)", margin: "0 auto 8px" }} />
                <div style={{ fontSize: 11, fontWeight: selected ? 600 : 400, color: selected ? T.charcoal : T.muted }}>{color.nombre}</div>
              </button>
            );
          })}
        </div>
      </div>

      <div style={C}>
        <div style={{ marginBottom: 16 }}>
          <h4 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 17, fontWeight: 500, marginBottom: 3 }}>Color de Tapas de Gavetas</h4>
          <p style={{ fontSize: 12, color: T.muted }}>Acabado exterior de puertas y tapas</p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))", gap: 10 }}>
          {MATERIALES_DATA.tapas.map(color => {
            const selected = sel.tapa === color.id;
            const isLight = parseInt(color.hex.slice(1, 3), 16) > 180;
            return (
              <button key={color.id} onClick={() => setVal("tapa", color.id)} style={{ border: selected ? `2px solid ${T.gold}` : `1px solid ${T.border}`, borderRadius: 10, overflow: "hidden", background: T.white, cursor: "pointer", transition: "all 180ms", position: "relative" }}>
                {selected && <div style={{ position: "absolute", top: 6, right: 6, width: 16, height: 16, borderRadius: "50%", background: T.gold, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1 }}><Ic d={I.check} s={9} c={T.white} /></div>}
                <div style={{ height: 52, background: color.hex, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <span style={{ fontSize: 9, fontWeight: 700, letterSpacing: ".1em", color: isLight ? "rgba(0,0,0,.3)" : "rgba(255,255,255,.4)", textTransform: "uppercase" }}>{color.ref}</span>
                </div>
                <div style={{ padding: "7px 10px", textAlign: "center" }}>
                  <div style={{ fontSize: 11, fontWeight: selected ? 600 : 400, color: selected ? T.charcoal : T.muted }}>{color.nombre}</div>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      <div style={C}>
        <div style={{ marginBottom: 16 }}>
          <h4 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 17, fontWeight: 500, marginBottom: 3 }}>Piedra de Encimera</h4>
          <p style={{ fontSize: 12, color: T.muted }}>Su proyecto incluye <strong>1 slab</strong>. Seleccione una opcion:</p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))", gap: 12, marginBottom: 14 }}>
          {MATERIALES_DATA.piedras.map(piedra => {
            const selected = sel.piedra === piedra.id;
            return (
              <button key={piedra.id} onClick={() => setVal("piedra", piedra.id)} style={{ border: selected ? `2px solid ${T.gold}` : `1px solid ${T.border}`, borderRadius: 10, overflow: "hidden", background: T.white, cursor: "pointer", transition: "all 180ms", textAlign: "left", position: "relative" }}>
                {selected && <div style={{ position: "absolute", top: 8, right: 8, width: 18, height: 18, borderRadius: "50%", background: T.gold, display: "flex", alignItems: "center", justifyContent: "center" }}><Ic d={I.check} s={10} c={T.white} /></div>}
                <div style={{ height: 68, background: `linear-gradient(135deg,${piedra.hex},${piedra.vena}44,${piedra.hex})` }} />
                <div style={{ padding: "10px 12px" }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: T.charcoal, marginBottom: 2 }}>{piedra.nombre}</div>
                  <div style={{ fontSize: 11, color: T.muted }}>{piedra.descripcion}</div>
                </div>
              </button>
            );
          })}
        </div>
        <div style={{ background: "rgba(197,165,114,.06)", border: `1px solid ${T.borderLight}`, borderLeft: `3px solid ${T.gold}`, borderRadius: 8, padding: "12px 16px", marginBottom: 10 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
            <div>
              <div style={{ fontSize: 12, fontWeight: 600, color: T.charcoal, marginBottom: 2 }}>Upgrade: 2 Slabs</div>
              <div style={{ fontSize: 11, color: T.muted, lineHeight: 1.5 }}>Costo adicional sujeto a cotizacion. El equipo se pondra en contacto.</div>
            </div>
            <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", flexShrink: 0 }}>
              <input type="checkbox" checked={sel.upgradeSlabs || false} onChange={e => setVal("upgradeSlabs", e.target.checked)} style={{ accentColor: T.gold }} />
              <span style={{ fontSize: 11, color: T.goldDark, fontWeight: 600 }}>Me interesa</span>
            </label>
          </div>
        </div>
        <div style={{ padding: "10px 14px", background: T.creamDeep, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span style={{ fontSize: 11, color: T.muted }}>Ver mas tipos de piedra disponibles:</span>
          <button onClick={() => show("Redirigiendo al catalogo de piedras")} style={{ ...BtnO, padding: "6px 14px", fontSize: 10 }}><Ic d={I.arrow} s={11} /> Ver catalogo</button>
        </div>
      </div>

      <div style={C}>
        <div style={{ marginBottom: 14 }}>
          <h4 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 17, fontWeight: 500, marginBottom: 3 }}>Electrodomesticos</h4>
          <p style={{ fontSize: 12, color: T.muted, lineHeight: 1.6 }}>Adjunte el PDF de compra para que podamos validar medidas exactas con el render.</p>
        </div>
        {mats.appliance_pdf ? (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", background: T.successBg, border: "1px solid rgba(90,138,74,.18)", borderRadius: 8 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <Ic d={I.file} s={20} c={T.success} />
              <div>
                <div style={{ fontSize: 12, fontWeight: 600, color: T.charcoal }}>{mats.appliance_pdf.name}</div>
                <div style={{ fontSize: 10, color: T.muted }}>Adjuntado el {fmtD(mats.appliance_pdf.uploadedAt)}</div>
              </div>
            </div>
            <button onClick={async () => { await supabase.from("materials").update({ appliance_pdf: null }).eq("project_id", p.id); refresh(); }} style={{ background: "none", border: "none", cursor: "pointer", color: T.muted }}><Ic d={I.x} s={14} /></button>
          </div>
        ) : (
          <label style={{ display: "block", cursor: "pointer" }}>
            <input type="file" accept=".pdf" onChange={handleApplPDF} style={{ display: "none" }} />
            <div style={{ border: `1.5px dashed ${T.border}`, borderRadius: 8, padding: "24px 20px", textAlign: "center" }}>
              <div style={{ width: 40, height: 40, borderRadius: "50%", background: "rgba(197,165,114,.1)", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 10 }}><Ic d={I.up} s={18} c={T.gold} /></div>
              <p style={{ fontSize: 13, fontWeight: 500, color: T.charcoal, marginBottom: 3 }}>Adjuntar PDF de electrodomesticos</p>
              <p style={{ fontSize: 11, color: T.muted }}>Haga clic para seleccionar el archivo</p>
            </div>
          </label>
        )}
      </div>

      <div style={{ ...C, background: "rgba(197,165,114,.04)", borderColor: "rgba(197,165,114,.3)" }}>
        <h4 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 16, marginBottom: 14 }}>Resumen de seleccion</h4>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 20 }}>
          {[
            ["Gavetas", sel.gavetaBody ? MATERIALES_DATA.gavetasBody.find(x => x.id === sel.gavetaBody)?.nombre : null],
            ["Tapas", sel.tapa ? MATERIALES_DATA.tapas.find(x => x.id === sel.tapa)?.nombre : null],
            ["Piedra", sel.piedra ? MATERIALES_DATA.piedras.find(x => x.id === sel.piedra)?.nombre : null],
            ["PDF Electrodomesticos", mats.appliance_pdf ? mats.appliance_pdf.name : null],
          ].map(([label, val]) => (
            <div key={label} style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ width: 16, height: 16, borderRadius: "50%", background: val ? T.successBg : T.creamDeep, border: `1px solid ${val ? T.success : T.border}`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                {val && <Ic d={I.check} s={9} c={T.success} />}
              </div>
              <div>
                <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".08em", textTransform: "uppercase", color: T.muted }}>{label}</div>
                <div style={{ fontSize: 11, color: val ? T.charcoal : T.faint }}>{val || "Pendiente"}</div>
              </div>
            </div>
          ))}
        </div>
        {!adm && (
          <button onClick={confirmar} style={{ ...Btn, width: "100%", justifyContent: "center", opacity: (sel.gavetaBody && sel.tapa && sel.piedra) ? 1 : .5, cursor: (sel.gavetaBody && sel.tapa && sel.piedra) ? "pointer" : "not-allowed" }}>
            <Ic d={I.check} s={14} c={T.white} /> Confirmar Selecciones
          </button>
        )}
        {!(sel.gavetaBody && sel.tapa && sel.piedra) && <p style={{ fontSize: 11, color: T.faint, textAlign: "center", marginTop: 8 }}>Complete gavetas, tapas y piedra para confirmar</p>}
      </div>
    </div>
  );
}